import { Box, Container, Grid } from '@mui/material';
import WeatherWidget from '../../components/WeatherWidget';
import CustomAppBar from '../../components/AppBar';
import CustomDashboardCard from '../../components/Custom/CustomDashboard';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import api from '../../globals/axios';
import CustomHierarchyTable from '../../components/Custom/CustomHierarchyTable';
import { useNavigate } from 'react-router-dom';
import QuickLinks from '../../components/QuickLinks';
import getQuickLinks from '../../Data/iconsData';

const POPManagerDashboard = () => {
  const { t } = useTranslation();
  const [popManagerDetails, setPopManagerDetails] = useState({});
  const [areaManagers, setAreaManagers] = useState([]);
  const navigate = useNavigate();
  const quickLinksData = getQuickLinks('pop_manager');

  const fetchPOPManagerDetails = async () => {
    try {
      const response = await api.get('/popmanager/get-pop-manager-details/');
      setPopManagerDetails(response.data);
    } catch (error) {
      console.error('Error Fetching POP Manager Details:', error);
    }
  };

  const fetchAreaManagersTargets = async () => {
    try {
      const response = await api.get('/popmanager/target-progress/');
      const transformedAreaManagers = response.data.area_manager_progress.map(
        areamanager => ({
          ...areamanager,
          farmer_target_display: `${areamanager.farmers_added}/${areamanager.farmer_target}`,
          area_target_display: `${areamanager.total_area_added}/${
            areamanager.area_target
          } ${t()}`,
        })
      );
      setAreaManagers(transformedAreaManagers);
    } catch (error) {
      console.error('Error Fetching Area Managers Targets:', error);
    }
  };

  useEffect(() => {
    fetchPOPManagerDetails();
    fetchAreaManagersTargets();
  }, []);

  const dataMapping = {
    project_count: 'Project Count',
    total_area_covered: 'Projected Area Covered',
    tree_count: 'Tree Count',
    // farmer_count: "Farmer Count",
    /*     ao_count: "AO Count",
    completed_programs_count: "Completed Programs",
    program_count: "Program Count", */
  };

  const transformedData = Object.entries(popManagerDetails).reduce(
    (acc, [key, value]) => {
      const label = dataMapping[key];
      if (label) {
        acc[label] = value;
      }
      return acc;
    },
    {}
  );
  const columns = [
    { label: 'Area Manager', field: 'area_manager_name', align: 'center' },
    { label: 'District', field: 'area_manager_address', align: 'center' },
    {
      label: 'Farmers Target',
      field: 'farmer_target_display',
      align: 'center',
    },
    {
      label: 'Area Target (acres)',
      field: 'area_target_display',
      align: 'center',
    },
    {
      label: 'Score',
      field: 'area_manager_score',
      align: 'center',
    },
  ];

  const handleRowClick = row => {
    navigate(`/area-manager/${row.area_manager_id}`);
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs" style={{ marginTop: 20 }}>
        <WeatherWidget />
        <Box mt={2}>
          <Grid container spacing={1} mt={0.5}>
            <Grid item xs={6}>
              <CustomDashboardCard
                title={t('Farmer count')}
                data={popManagerDetails.farmer_count || 0}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomDashboardCard
                title={t('Total Area Managers')}
                data={popManagerDetails.ao_count || 0}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomDashboardCard
                title={t('Total Area')}
                data={popManagerDetails.total_area || 0.0}
                unit={`${t('acres')}`}
              />
            </Grid>

            <Grid item xs={6}>
              <CustomDashboardCard
                title={t('Programs Completed')}
                data={popManagerDetails.completed_programs_count || 0}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomDashboardCard
                title={t('Assigned Programs')}
                data={popManagerDetails.program_count || 0.0}
              />
            </Grid>
          </Grid>
        </Box>
        <Box mt={2}>
          <CustomDashboardCard title="Project Details" data={transformedData} />
        </Box>
        <Box mt={2}>
          <CustomHierarchyTable
            columns={columns}
            data={areaManagers}
            onRowClick={handleRowClick}
          />
        </Box>
        <Box mt={2}>
          <QuickLinks data={quickLinksData} />
        </Box>
      </Container>
    </>
  );
};

export default POPManagerDashboard;
